module.exports = __webpack_public_path__ + "img/forward-arrow-primary.9122c490.svg";